import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=47f8d98c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f8d98c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47f8d98c')) {
      api.createRecord('47f8d98c', component.options)
    } else {
      api.reload('47f8d98c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=47f8d98c&scoped=true&", function () {
      api.rerender('47f8d98c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N8wOl4QNak5Y/JS/comp/Accordion.vue"
export default component.exports